import { PaginationModule } from './pagination/pagination.module';
import { OrdersModule } from 'app/orders/orders.module';
import { APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserXhr } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { Angulartics2Module } from 'angulartics2';
import { SelectModule } from 'ng-select';

import { AccountService } from './user/account.service';
import { AnalyticsModule } from './analytics/analytics.module';
import { apiFactory } from './core/api.factory';
import { AppComponent } from './app.component';
import { ApplicationsModule } from './applications/applications.module';
import { AppRootStylerComponent } from './user/app-root-styler/app-root-styler';
import { AppRoutingModule } from './app-routing.module';
import { AuthFooterComponent } from './user/auth-footer/auth-footer.component';
import { AuthHeaderComponent } from './user/auth-header/auth-header.component';
import { AuthService } from './user/auth.service';
import { ChangeRegionComponent } from 'app/core/change-region/change-region.component';
import { CoreModule } from './core/core.module';
import { DefaultService } from './services/default.service';
import { DownloadService } from './files/download.service';
import { EnvironmentService } from './services/environment.sevice';
import { EqualValidatorDirective } from './user/password-change/equal.validator';
import { FeatureRequestModule } from './user/feature-request/feature-request.module';
import { FeedbackModule } from './feedback/feedback.module';
import { GeolocationService } from './services/geolocation.service';
import { LimitsService } from './services/limits.service';
import { LocalStorageService } from './services/storage/local-storage.service';
import { LoginComponent } from './user/login/login.component';
import { MemoryStorageService } from './services/storage/memory-storage.service';
import { NotificationsModule } from 'app/notifications/notifications.module';
import { OrderListService } from './orders/orders.service';
import { OrderService } from './orders/order.service';
import { PasswordChangeComponent } from './user/password-change/password-change.component';
import { PasswordRecoverComponent } from './user/password-recover/password-recover.component';
import { PostMessageService } from './services/post-message.service';
import { ProgressBrowserXhr } from './core/upload-progress.service';
import { ProgressService } from './core/upload-progress.service';
import { RegisterComponent } from './user/register/register.component';
import { RoutingService } from './services/routing.service';
import { ShellComponent } from './core/shell/shell.component';
import { SidebarComponent } from './core/sidebar/sidebar.component';
import { SidebarSettingsService } from './core/sidebar/sidebar-settings.service';
import { UIModule } from './ui/ui.module';
import { UserService } from './user/user.service';
import { UserSettingsService } from './user/user-settings.service';

@NgModule({
  imports: [
    Angulartics2Module.forRoot(),
    AnalyticsModule,
    AppRoutingModule,
    ApplicationsModule,
    BrowserModule,
    OrdersModule,
    PaginationModule,
    BrowserAnimationsModule,
    CoreModule.forRoot(),
    FeatureRequestModule,
    FeedbackModule,
    FormsModule,
    NotificationsModule,
    SelectModule,
    UIModule
  ],
  declarations: [
    AppComponent,
    AppRootStylerComponent,
    AuthFooterComponent,
    AuthHeaderComponent,
    ChangeRegionComponent,
    EqualValidatorDirective,
    LoginComponent,
    PasswordChangeComponent,
    PasswordRecoverComponent,
    RegisterComponent,
    ShellComponent,
    SidebarComponent
  ],
  entryComponents: [ChangeRegionComponent],
  providers: [
    AccountService,
    AuthService,
    DefaultService,
    DownloadService,
    EnvironmentService,
    GeolocationService,
    LocalStorageService,
    MemoryStorageService,
    OrderListService,
    OrderService,
    PostMessageService,
    ProgressService,
    RoutingService,
    SidebarSettingsService,
    LimitsService,
    UserService,
    UserSettingsService,
    {
      provide: APP_INITIALIZER,
      useFactory: apiFactory,
      deps: [AuthService],
      multi: true
    },
    {
      provide: BrowserXhr,
      useClass: ProgressBrowserXhr,
      deps: [ProgressService]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
